








































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TotalSegment } from '@/store/models';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';
import ShippingFreeMessage from '@/components/Shipping/FreeMessage.vue';
import store from '@/store';
import { oneyRates } from '@/store/api';
import to from 'await-to-js';
import Modal from '@/components/UI/Modal.vue';
import ui from '@/store/modules/ui';
import OneyRates from '@/components/Cart/OneyRates.vue';
import Tax from '@/components/Sidebar/Tax.vue';

@Component({
    components: {
        ShippingFreeMessage,
        Modal,
        OneyRates,
        Tax,
    },
})
export default class TotalsComp extends Vue {
    @Prop() private totalSegments!: TotalSegment[];
    @Prop() private showOnlyGrandTotal!: boolean;
    private showOneyPopup: boolean = false;
    private oney: any = false;

    get loading(): boolean {
        return cart.loadingFlags.totals;
    }

    get isCart() {
        return this.$route.params.step === 'cart' || typeof this.$route.params.step === 'undefined';
    }

    get grandTotal() {
        const grandTotal = this.totalSegments.find((total) => {
            return total.code === 'grand_total';
        });
        return grandTotal ? grandTotal.value : 0;
    }

    get sortedTotals(): TotalSegment[] {
        const totals = this.totalSegments;
        const sort: any = {
            subtotal: 10,
            wf_tax_rule: 15,
            shipping: 50,
            default: 80,
            grand_total: 99,
        };
        totals.sort((a: TotalSegment, b: TotalSegment) => {
            const pa = sort[a.code] || sort.default;
            const pb = sort[b.code] || sort.default;
            if (pa < pb) {
                return -1;
            }
            if (pb < pa) {
                return 1;
            }
            return 0;
        });
        return totals;
    }

    public isZero(totalSegment: TotalSegment) {
        return !totalSegment.value;
    }
    get giftCardMessage() {
        const key = 'giftcardaccount';
        return checkout.messages[key];
    }

    public canShow(totalSegment: TotalSegment) {
        if (totalSegment.code === 'tax') {
            return false;
        }

        if (totalSegment.code !== 'grand_total' && this.showOnlyGrandTotal) {
            return false;
        }

        // Always show grand total, even if free
        if (totalSegment.code === 'grand_total') {
            return true;
        }

        if (totalSegment.code === 'shipping') {
            return true;
        }

        if (totalSegment.code.indexOf('pu_shipping_notice') !== -1 && checkout.shippingOptions.notice.selected) {
            return true;
        }

        if (totalSegment.code.indexOf('pu_shipping_skip') !== -1 && checkout.shippingOptions.skip.selected) {
            return true;
        }

        return totalSegment.value && totalSegment.value !== 0;
    }

    public getTitle(totalSegment: TotalSegment): any {
        if (totalSegment.code === 'grand_total') {
            return this.$t('Total');
        }

        if (totalSegment.code === 'shipping') {
            if (this.isZero(totalSegment)) {
                return this.$t('Free shipping');
            }

            return this.$t('Shipping');
        }

        return totalSegment.title;
    }

    public isGrandTotal(totalSegment: TotalSegment) {
        return totalSegment.code === 'grand_total';
    }

    private mounted() {
        this.initOney();
    }

    @Watch('totalSegments')
    private onChangeCheckoutTotals(val: any, oldVal: any) {
        const grandTotal = val.find((total: any) => total.code === 'grand_total');
        const oldGrandTotal = oldVal.find((oldtotal: any) => oldtotal.code === 'grand_total');

        if (grandTotal.value !== oldGrandTotal.value) {
            this.initOney();
        }
    }

    private initOney() {
        const paymentConfig = store.state.options.payment;
        if (paymentConfig.hipay_oney && paymentConfig.hipay_oney.active) {
            const total = cart.totals.base_grand_total;

            if (total >= paymentConfig.hipay_oney.min && total <= paymentConfig.hipay_oney.max) {
                this.initOneyRates();
            } else {
                this.oney = false;
            }
        }
    }

    private async initOneyRates() {
        const data = await to(oneyRates());
        const [error]: any = data;
        let [, res]: any = data;

        if (error) {
            res = false;
            this.oney = false;
        } else {
            store.state.options.payment.hipay_oney.rates = res;
            this.oney = JSON.parse(res);
            (window as any).oney = this.oney;
        }
    }

    private openModal(modalId: string) {
        ui.openModal(modalId);
    }

    private closeModal(modalId: string) {
        ui.closeModal(modalId);
    }
}
